import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-test-display',
  imports: [FormsModule],
  templateUrl: './test-display.component.html',
  styleUrl: './test-display.component.scss'
})
export class TestDisplayComponent {
  private readonly router = inject(Router);

  siteId = '';
  displayId = '';

  navigate(): void {
    if (this.siteId.trim() && this.displayId.trim()) {
      this.router.navigate(['/parking-sites', this.siteId.trim(), 'display', this.displayId.trim()]);
    }
  }
}
